import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { useState } from "react";
import Select from "@/components/UiKit/Select/Select";
import RadioButtonMD from "./RadioButtonMD";
import api__postUserWorkInfo from "@/apis/freeFinance/api__postUserWorkInfo";
import { trackEvents } from "@/common/events/events";
import { useParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import InputCurrency from "@componentsShared/InputCurrency/InputCurrency";
import { If } from "@componentsShared/Conditional/If";
var WorkInfoComponent = function WorkInfoComponent(_ref) {
  var queryParams = _ref.queryParams,
    updateLoader = _ref.updateLoader,
    post_id = _ref.post_id,
    g4Data = _ref.g4Data;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var params = useParams();
  var financeApplyData = JSON.parse(sessionStorage.getItem("finance_apply_data"));
  var financial_liabilities = !financeApplyData ? null : (financeApplyData === null || financeApplyData === void 0 ? void 0 : financeApplyData.deduction) > 0 ? "1" : "0";
  var total_financial_liabilities_value = !financeApplyData ? null : (financeApplyData === null || financeApplyData === void 0 ? void 0 : financeApplyData.deduction) > 0 ? financeApplyData === null || financeApplyData === void 0 ? void 0 : financeApplyData.deduction.toString() : null;
  var _useState = useState({
      work_sector: null,
      employer_name: null,
      salary: (financeApplyData === null || financeApplyData === void 0 ? void 0 : financeApplyData.salary.toString()) || null,
      salary_transfer_method: null,
      traffic_fine: null,
      traffic_fine_value: null,
      other_financial_liabilities: financial_liabilities,
      total_financial_liabilities: total_financial_liabilities_value,
      order_uuid: queryParams.get("uuid")
    }),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = useState(null),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState([{
      name: t("choose_employer", {
        ns: "web_checkout_finance"
      }),
      id: ""
    }, {
      name: t("retired", {
        ns: "web_checkout_finance"
      }),
      id: "4"
    }, {
      name: t("governmental", {
        ns: "web_checkout_finance"
      }),
      id: "0"
    }, {
      name: t("civil_government", {
        ns: "web_checkout_finance"
      }),
      id: "1"
    }, {
      name: t("special", {
        ns: "web_checkout_finance"
      }),
      id: "2"
    }]),
    workSectorOptions = _useState3[0];
  var id = params === null || params === void 0 ? void 0 : params.id;
  var isFromFinanceCalculator = useMemo(function () {
    var id = params === null || params === void 0 ? void 0 : params.id;
    var financeCalculator = sessionStorage.getItem("installment-calculator-".concat(id));
    return !!financeCalculator;
  }, []);
  var _useState4 = useState([{
      name: t("select", {
        ns: "web_checkout_finance"
      }),
      id: ""
    }, {
      name: t("cash", {
        ns: "web_checkout_finance"
      }),
      id: "-1"
    }, {
      name: t("receive_check", {
        ns: "web_checkout_finance"
      }),
      id: "-2"
    }, {
      name: t("ahli_bank", {
        ns: "web_checkout_finance"
      }),
      id: "2"
    }, {
      name: t("first_bank", {
        ns: "web_checkout_finance"
      }),
      id: "4"
    }, {
      name: t("saudi_fransi_bank", {
        ns: "web_checkout_finance"
      }),
      id: "18"
    }, {
      name: t("emirates_bank", {
        ns: "web_checkout_finance"
      }),
      id: "15"
    }, {
      name: t("investment_bank", {
        ns: "web_checkout_finance"
      }),
      id: "5"
    }, {
      name: t("development_bank", {
        ns: "web_checkout_finance"
      }),
      id: "12"
    }, {
      name: t("national_bank", {
        ns: "web_checkout_finance"
      }),
      id: "7"
    }, {
      name: t("al_jazeera_bank", {
        ns: "web_checkout_finance"
      }),
      id: "8"
    }, {
      name: t("al_rajhi_bank", {
        ns: "web_checkout_finance"
      }),
      id: "1"
    }, {
      name: t("riyad_bank", {
        ns: "web_checkout_finance"
      }),
      id: "3"
    }, {
      name: t("arab_bank", {
        ns: "web_checkout_finance"
      }),
      id: "6"
    }, {
      name: t("sabb_bank", {
        ns: "web_checkout_finance"
      }),
      id: "16"
    }, {
      name: t("samba_bank", {
        ns: "web_checkout_finance"
      }),
      id: "10"
    }]),
    salaryTransfer = _useState4[0];
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage;
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var updateData = function updateData(key, value) {
    setData(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var updateErrors = function updateErrors(key, value) {
    setErrors(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var sendData = function sendData() {
    updateLoader(true);
    //filter data and find salary convert to int
    var dataToSend = _objectSpread({}, data);
    api__postUserWorkInfo(dataToSend).then(function (res) {
      var _res$data, _res$data$data;
      updateLoader(false);
      if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.status) === 0) {
        var referral_location = getLocalStorage("referral_location") || "";
        var from_car_comparison = referral_location === "car_comparison";
        var submission_source = getSubmissionSource();
        trackEvents("finance_form_submit", _objectSpread(_objectSpread({}, g4Data), {}, {
          salary: data.salary,
          inventory_type_string: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
          salary_transfer: data.salary_transfer_method,
          post_trim: g4Data.post_ext,
          status: "rejected",
          referral_location: submission_source,
          finance_type: "free"
        }));
        navigateTo("/finance/rejected?haveanotherOrder=2&post_id=".concat(post_id));
      } else if (res.data.code === 200) {
        var _res$data2, _res$data2$data;
        var _referral_location = getLocalStorage("referral_location") || "";
        var _from_car_comparison = _referral_location === "from_car_comparison";
        sessionStorage.removeItem("finance_apply_data");
        var _submission_source = getSubmissionSource();
        trackEvents("finance_form_submit", _objectSpread(_objectSpread({
          order_id: res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.order_id
        }, g4Data), {}, {
          salary: data.salary,
          inventory_type_string: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
          salary_transfer: data.salary_transfer_method,
          post_trim: g4Data.post_ext,
          status: "accepted",
          referral_location: _submission_source,
          finance_type: "free"
        }));
        navigateTo("/finance-apply-free/".concat(post_id), {
          financestep: 3,
          uuid: data["order_uuid"],
          orderid: res.data.data.order_id
        });
      } else {
        if (res.data.code === 230) {
          setErrors(res.data.errors);
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: stl.InfoComponentContainer
  }, /*#__PURE__*/React.createElement("strong", null, t("enter_business_information", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(Select, {
    className: stl.formStyle,
    name: "work_sector",
    topLabel: t("employer", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors.work_sector : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.work_sector) && updateErrors("work_sector", "");
    },
    onChange: function onChange(event) {
      updateData("work_sector", event.currentTarget.value);
    }
  }, workSectorOptions.map(function (city, idx) {
    return idx == 0 ? /*#__PURE__*/React.createElement("option", {
      disabled: true,
      selected: true,
      hidden: true
    }, t("select", {
      ns: "web_checkout_finance"
    })) : /*#__PURE__*/React.createElement("option", {
      key: city.id,
      value: city.id
    }, city.name);
  })), data["work_sector"] && +data["work_sector"] !== 0 && /*#__PURE__*/React.createElement(Input, {
    className: stl.formStyle,
    name: "sectorName",
    label: t("employer_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.employer_name : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.employer_name) && updateErrors("employer_name", "");
    },
    onChange: function onChange(event) {
      updateData("employer_name", event.currentTarget.value);
    },
    value: data["employer_name"]
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-8 flex gap-1 flex-col"
  }, /*#__PURE__*/React.createElement(InputCurrency, {
    inputClassName: "custom-input-class",
    defaultValue: data["salary"],
    currencyLabel: data["salary"] ? t("sar", {
      ns: "web_sell_trade"
    }) : "" // Currency label
    ,
    label: t("salary_without_additional_living_expenses", {
      ns: "web_checkout_finance"
    }) // Placeholder/Label
    ,
    lang: "en" // Language for formatting (en or ar)
    ,
    errorLabel: "" // Error message (if any)
    ,
    onChange: function onChange(value) {
      updateData("salary", value);
      updateErrors("salary", "");
    }
  }), /*#__PURE__*/React.createElement(If, {
    condition: errors === null || errors === void 0 ? void 0 : errors.salary
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#f71e1e] text-xs"
  }, errors === null || errors === void 0 ? void 0 : errors.salary))), /*#__PURE__*/React.createElement(Select, {
    className: stl.formStyle,
    name: "salary_transfer_method",
    topLabel: t("how_transfer_salary", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors.salary_transfer_method : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.salary_transfer_method) && updateErrors("salary_transfer_method", "");
    },
    onChange: function onChange(event) {
      updateData("salary_transfer_method", event.currentTarget.value);
    }
  }, salaryTransfer.map(function (city, idx) {
    return idx == 0 ? /*#__PURE__*/React.createElement("option", {
      disabled: true,
      selected: true,
      hidden: true
    }, t("select", {
      ns: "web_checkout_finance"
    })) : /*#__PURE__*/React.createElement("option", {
      key: city.id,
      value: city.id
    }, city.name);
  })), /*#__PURE__*/React.createElement(RadioButtonMD, {
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.traffic_fine : "",
    className: stl.formStyle,
    onChange: function onChange(event) {
      (errors === null || errors === void 0 ? void 0 : errors.traffic_fine) && updateErrors("traffic_fine", "");
      updateData("traffic_fine", event.currentTarget.value);
    },
    label: t("traffic_violations", {
      ns: "web_checkout_finance"
    }),
    name: "traffic_fine",
    options: [{
      title: t("yes_violations", {
        ns: "web_checkout_finance"
      }),
      value: "1"
    }, {
      title: t("violations", {
        ns: "web_checkout_finance"
      }),
      value: "0"
    }]
  }), +data["traffic_fine"] === 1 && /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_checkout_finance"
    }),
    className: stl.formStyle,
    name: "sectorName",
    label: t("value_violations", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.traffic_fine_value : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.traffic_fine_value) && updateErrors("traffic_fine_value", "");
    },
    onChange: function onChange(event) {
      updateData("traffic_fine_value", event.currentTarget.value);
    },
    value: data["traffic_fine_value"]
  }), /*#__PURE__*/React.createElement(RadioButtonMD, {
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.other_financial_liabilities : "",
    className: stl.formStyle,
    selected: data["other_financial_liabilities"],
    onChange: function onChange(event) {
      (errors === null || errors === void 0 ? void 0 : errors.other_financial_liabilities) && updateErrors("other_financial_liabilities", "");
      updateData("other_financial_liabilities", event.currentTarget.value);
    },
    label: t("financial_obligations_banks_financial_institutions", {
      ns: "web_checkout_finance"
    }),
    name: "other_financial_liabilities",
    options: [{
      title: t("yes_there_obligations", {
        ns: "web_checkout_finance"
      }),
      value: "1"
    }, {
      title: t("there_obligations", {
        ns: "web_checkout_finance"
      }),
      value: "0"
    }]
  }), +data["other_financial_liabilities"] === 1 && /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_checkout_finance"
    }),
    className: stl.formStyle,
    name: "sectorName",
    label: t("value_obligations", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.total_financial_liabilities : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.total_financial_liabilities) && updateErrors("total_financial_liabilities", "");
    },
    onChange: function onChange(event) {
      updateData("total_financial_liabilities", event.currentTarget.value);
    },
    value: data["total_financial_liabilities"]
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      sendData();
    }
  }, /*#__PURE__*/React.createElement("strong", null, t("next_step", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null))));
};
export default WorkInfoComponent;